import { Alert } from 'react-native';

export function confirmBlockingOtpAbort(t: (key: string) => string, on_abort: () => void): void {
  Alert.alert(t('common.confirm'), t('auth.otpCancelConfirmMessage'), [
    { text: t('common.cancel'), style: 'cancel' },
    { text: t('common.confirm'), onPress: on_abort },
  ]);
}
